import React from 'react'
import PropTypes from 'prop-types'

import UnitIcon from 'src/ui/UnitIcon/UnitIcon'
import { shouldUnitBeGreyedOut } from 'src/utils/unit'

import UnitInfoSkeleton from './UnitInfoSkeleton'

const UnitInfo = ({ unit, children }) => (
  <UnitInfoSkeleton
    nameSection={unit.name}
    iconSection={
      unit.iconUrl && (
        <UnitIcon
          iconSize="100%"
          name={unit.name}
          iconUrl={unit.iconUrl}
          isCompleted={unit.progress?.isCompleted}
          shouldBeGreyedOut={shouldUnitBeGreyedOut(unit.progress)}
        />
      )
    }
  >
    {children}
  </UnitInfoSkeleton>
)

UnitInfo.propTypes = {
  unit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    iconUrl: PropTypes.string,
    progress: PropTypes.shape({
      isCompleted: PropTypes.bool,
    }),
  }),
  children: PropTypes.any,
}

export default UnitInfo
